module.exports = __webpack_public_path__ + "static/media/Divertido.acd100f6.png";